import React, { useState, useEffect } from "react";
import "./styles.css";
import { Category } from "common/utils/menu-helper-utils";
import { useSelector } from "react-redux";
import { RootState } from "common/rootReducer";

interface CategoryFilterProps {
  categories: Category;
  setCurrentCategory: any;
  currentCategory: string;
  showCategory: any;
  specialMenuNames?: any;
  isSpecialMenuAvailable?: any;
  setCurrentRestaurantDishViewType?: any;
  isPreviouslyOrderedMenuAvailable?: any;
  previouslyOrderedMenuName?: any;
  setCurrentRestaurantDishViewTypeExclusive?: any;
}
const MenuHeader = (props: CategoryFilterProps) => {
  const [showCategories, setShowCategories] = useState(false);
  const [isSafari, setisSafari] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const menuCategories: Array<string> = useSelector(
    (state: RootState) => state.restaurant.restaurantMenuCategories
  );

  useEffect(() => {
    let ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("safari") != -1) {
      if (ua.indexOf("chrome") > -1) {
        // Chromes
      } else {
        setisSafari(true); // Safari
      }
    }
  }, []);

  useEffect(() => {
    if (
      props.currentCategory &&
      props.categories[props.currentCategory] &&
      props.categories[props.currentCategory].subCategories.length > 0
    ) {
      setSelectedSubCategory(
        props.categories[props.currentCategory].subCategories[0]
      );
    }
  }, [props.currentCategory]);

  return (
    <div className="menuHeader-container">
      <div id="menuHeader-category-container">
        <div className="menuHeader-category-container">
          <div
            className={
              selectedCategory == ""
                ? "menuHeader-category-value menuHeader-category-value-selected "
                : "menuHeader-category-value"
            }
            onClick={() => {
              if (selectedCategory == "") {
                props.setCurrentCategory("");
                setSelectedCategory("");
                setSelectedSubCategory("");
                props.setCurrentRestaurantDishViewType("All Items");
                props.setCurrentRestaurantDishViewTypeExclusive("Exclusive");
              } else {
                setSelectedCategory("");
                props.setCurrentRestaurantDishViewType("All Items");
                props.setCurrentRestaurantDishViewTypeExclusive("Exclusive");

                props.showCategory("");
                props.setCurrentCategory("");
              }
              setShowCategories(false);
            }}
          >
            <span className="category-text">All</span>
          </div>
        </div>

        {((props.previouslyOrderedMenuName.length > 0 &&
          props.isPreviouslyOrderedMenuAvailable) ||
          (props.specialMenuNames.length > 0 &&
            props.isSpecialMenuAvailable)) && (
          <div
            className="menuHeader-category-container"
            style={{ maxWidth: "200px" }}
          >
            <div
              className={
                selectedCategory == "Recommendation"
                  ? "menuHeader-category-value menuHeader-category-value-selected "
                  : "menuHeader-category-value"
              }
              onClick={() => {
                if (selectedCategory == "Recommendation") {
                  setSelectedCategory("");
                  props.setCurrentCategory("");
                  props.setCurrentRestaurantDishViewType("All Items");
                  props.setCurrentRestaurantDishViewTypeExclusive("not Exclusive");

                } else {
                  props.setCurrentCategory("");
                  setSelectedCategory("Recommendation");
                  if (
                    props.specialMenuNames.length > 0 &&
                    props.isSpecialMenuAvailable
                  ) {
                    props.setCurrentRestaurantDishViewType("Special Menu");
                    props.setCurrentRestaurantDishViewTypeExclusive("not Exclusive");

                    setSelectedSubCategory("Special Menu");
                  } else {
                    setSelectedSubCategory("Previously Ordered");
                    props.setCurrentRestaurantDishViewType(
                      "Previously Ordered"
                    );
                    props.setCurrentRestaurantDishViewTypeExclusive("not Exclusive");

                  }
                }
                setShowCategories(false);
              }}
            >
              <span className="category-text">Recommendations</span>
            </div>
          </div>
        )}

        {menuCategories &&
          menuCategories
            .filter((category) =>
              Object.keys(props.categories).includes(category)
            )
            .map((category: string, index: number) => (
              <div key={index}>
                <div
                  className={
                    selectedCategory == category
                      ? "menuHeader-category-value menuHeader-category-value-selected "
                      : "menuHeader-category-value"
                  }
                  key={index}
                  onClick={() => {
                    if (selectedCategory == category) {
                      props.setCurrentCategory("");
                      setSelectedCategory("");
                      props.setCurrentRestaurantDishViewTypeExclusive("not Exclusive");

                    } else {
                      props.setCurrentRestaurantDishViewType("All Items");
                      props.setCurrentRestaurantDishViewTypeExclusive("not Exclusive");

                      setSelectedCategory(category);
                      props.showCategory(category);
                      props.setCurrentCategory(category);
                    }
                    setShowCategories(false);
                  }}
                >
                  <div>
                    <span className="category-text">{category}</span>
                  </div>
                </div>
              </div>
            ))}
      </div>

      {((props.previouslyOrderedMenuName.length > 0 &&
        props.isPreviouslyOrderedMenuAvailable) ||
        (props.specialMenuNames.length > 0 && props.isSpecialMenuAvailable)) &&
        props.currentCategory === "" &&
        selectedCategory === "Recommendation" && (
          <div className="subcategory-list-container">
            {props.specialMenuNames.length > 0 && props.isSpecialMenuAvailable && (
              <div
                className={
                  selectedSubCategory == "Special Menu"
                    ? "subcategory-container selected-subcategory-container"
                    : "subcategory-container"
                }
                onClick={() => {
                  setSelectedSubCategory("Special Menu");
                  props.setCurrentCategory("");
                  props.setCurrentRestaurantDishViewType("Special Menu");
                  // setSelectedCategory("Special Menu");
                  // props.showCategory("Special Menu");

                  setShowCategories(false);
                }}
              >
                <span className="subcategory-text">
                  {"Special Menu".toLocaleUpperCase()}
                </span>
              </div>
            )}

            {props.previouslyOrderedMenuName.length > 0 &&
              props.isPreviouslyOrderedMenuAvailable && (
                <div
                  className={
                    selectedSubCategory == "Previously Ordered"
                      ? "subcategory-container selected-subcategory-container"
                      : "subcategory-container"
                  }
                  onClick={() => {
                    setSelectedSubCategory("Previously Ordered");
                    props.setCurrentCategory("");
                    props.setCurrentRestaurantDishViewType(
                      "Previously Ordered"
                    );
                    // setSelectedCategory("Special Menu");
                    // props.showCategory("Special Menu");

                    setShowCategories(false);
                  }}
                >
                  <span className="subcategory-text">
                    {"Previously Ordered".toLocaleUpperCase()}
                  </span>
                </div>
              )}
          </div>
        )}

      {props.currentCategory && props.currentCategory && (
        <div className="subcategory-list-container">
          {props.categories[props.currentCategory] &&
            props.categories[props.currentCategory].subCategories &&
            props.categories[props.currentCategory].subCategories.map(
              (u, i) => {
                return (
                  <div
                    className={
                      selectedSubCategory == u
                        ? "subcategory-container selected-subcategory-container"
                        : "subcategory-container"
                    }
                    onClick={() => {
                      setSelectedSubCategory(u);
                      setTimeout(() => {
                        const yOffset = -130;
                        const item = document.querySelector(
                          ".restore-" +
                            u.toLocaleUpperCase().replace(/[^a-zA-Z]/g, "")
                        );
                        if (item) {
                          // if (isSafari) {
                            item.scrollIntoView({
                              behavior: "smooth",
                              block: "center",
                              inline: "start",
                            });
                            //other browser logic commented
                          //  } else {
                          //   const y =
                          //     item.getBoundingClientRect().top +
                          //     window.pageYOffset +
                          //     yOffset;
                          //   window.scrollTo({ top: y, behavior: "smooth" });
                          // }
                        }
                      }, 10);
                    }}
                  >
                    <span className="subcategory-text">
                      {u.toLocaleUpperCase()}
                    </span>
                  </div>
                );
              }
            )}
        </div>
      )}
    </div>
  );
};

export default MenuHeader;
